export default __webpack_public_path__ + "static/media/img-gtl-crs@2x.d74491bf.png";